import { render, staticRenderFns } from "./PreExistingWillForm.vue?vue&type=template&id=00d4c748"
import script from "./PreExistingWillForm.vue?vue&type=script&lang=js"
export * from "./PreExistingWillForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports